import script from "./Liabilities.vue?vue&type=script&setup=true&lang=js"
export * from "./Liabilities.vue?vue&type=script&setup=true&lang=js"

import "./Liabilities.vue?vue&type=style&index=0&id=e32eea6e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e32eea6e"]])

export default __exports__